import React from "react";

// Small, safe markdown renderer: builds React elements only (no raw HTML is ever injected).
// Supports: ## / ### headings, paragraphs, - and 1. lists, > quotes, **bold**, *italic*, [links](url), ![images](url).
const safeUrl = (u) => (/^(https?:\/\/|\/|mailto:|#)/i.test(u) ? u : "#");

function inline(text, keyBase) {
  const out = [];
  const re = /(!\[([^\]]*)\]\(([^)\s]+)\)|\[([^\]]+)\]\(([^)\s]+)\)|\*\*([^*]+)\*\*|\*([^*]+)\*)/g;
  let last = 0, m, i = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const k = `${keyBase}-${i++}`;
    if (m[3]) out.push(<img key={k} src={safeUrl(m[3])} alt={m[2]} loading="lazy" style={{ maxWidth: "100%", margin: "1em 0" }} />);
    else if (m[5]) out.push(<a key={k} href={safeUrl(m[5])} {...(/^https?:/i.test(m[5]) ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{m[4]}</a>);
    else if (m[6]) out.push(<strong key={k}>{m[6]}</strong>);
    else if (m[7]) out.push(<em key={k}>{m[7]}</em>);
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export default function Markdown({ source = "" }) {
  const blocks = String(source).replace(/\r\n/g, "\n").split(/\n{2,}/);
  return (
    <>
      {blocks.map((raw, i) => {
        const b = raw.trim();
        if (!b) return null;
        const k = `b${i}`;
        let m;
        if ((m = b.match(/^(#{1,4})\s+(.*)$/s))) {
          const level = Math.min(Math.max(m[1].length + 1, 2), 4); // # becomes h2 (page title is the h1)
          return React.createElement(`h${level}`, { key: k }, inline(m[2], k));
        }
        if (/^([-*]\s+.*(\n|$))+$/.test(b))
          return <ul key={k}>{b.split("\n").map((l, j) => <li key={j}>{inline(l.replace(/^[-*]\s+/, ""), `${k}-${j}`)}</li>)}</ul>;
        if (/^(\d+\.\s+.*(\n|$))+$/.test(b))
          return <ol key={k}>{b.split("\n").map((l, j) => <li key={j}>{inline(l.replace(/^\d+\.\s+/, ""), `${k}-${j}`)}</li>)}</ol>;
        if (b.startsWith(">"))
          return <blockquote key={k}>{inline(b.replace(/^>\s?/gm, ""), k)}</blockquote>;
        return <p key={k}>{inline(b.replace(/\n/g, " "), k)}</p>;
      })}
    </>
  );
}
